@import '../../../globals/main.scss';

pn-date-and-time {
  pn-date-picker .pn-date-picker {
    container-type: normal;
  }

  label {
    color: $gray700;
    font-size: 1.4rem;
  }

  .time-separator {
    margin-top: auto;
    margin-bottom: auto;
  }

  .date-and-time-group {
    margin-bottom: 1rem;
  }

  .date-and-time-row {
    display: flex;
    gap: 1rem;
  }

  .helper-text {
    margin-top: 0.2rem;
    color: $gray700;
    display: block;
  }

  .error-message {
    color: #a70707;
  }
}